// import _ from 'lodash';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Responsive } from 'common/components';
// import { Redirect } from 'react-router-dom';
// import { CATEGORY_ROUTE, CLOSED_VOTES_ROUTE } from 'client/constants';
import { CATEGORY_ROUTE, CATEGORY_TITLES } from 'client/constants';
import { Header, Container, RabbiCredit } from 'client/components/common';
import { CSSTransition } from 'react-transition-group';
import _ from 'lodash';
import Category from './Category';
import * as css from './Category.scss';

class CategoryContainer extends Component {
	timeout = null;

	static propTypes = {
		match: PropTypes.shape({
			params: PropTypes.shape({
				categoryId: PropTypes.string,
			}),
		}).isRequired,
		history: PropTypes.shape({
			push: PropTypes.func.isRequired,
		}).isRequired,
		user: PropTypes.shape({}).isRequired,
		categories: PropTypes.shape({}).isRequired,
		items: PropTypes.shape({}).isRequired,
		isFetching: PropTypes.bool.isRequired,
		getItems: PropTypes.func.isRequired,
		getCategories: PropTypes.func.isRequired,
		getCategorySelection: PropTypes.func.isRequired,
		setCategorySelection: PropTypes.func.isRequired,
		submitSelection: PropTypes.func.isRequired,
		isStarted: PropTypes.bool.isRequired,
		in: PropTypes.bool.isRequired,
	};

	constructor(props) {
		super(props);

		this.isRedirected = false;

		this.state = {
			isScrolling: false,
			isHideInHeader: false,
			animationState: '',
		};
	}

	componentDidMount = async () => {
		document.addEventListener('scroll', this.onScroll, { passive: true });
		// await this.props.getCategories();
	};

	componentWillUnmount() {
		if (Responsive.isMatching(Responsive.MOBILE)) {
			document.removeEventListener('scroll', this.onScroll);
			clearTimeout(this.timeout);
		}
	}

	onScroll = _.throttle(() => {
		// const { offsetScroll } = this.state;

		if (Responsive.isMatching(Responsive.MOBILE)) {
			if (window.scrollY > 10) {
				this.setState({ isScrolling: true, isHideInHeader: true });
			} else {
				this.setState({ isScrolling: false, isHideInHeader: false });
			}
		}

		// if (Responsive.isMatching(Responsive.DESKTOP)) {
		// 	if (window.pageYOffset > 50) {
		// 		this.setState({ isScrolling: true, isHideInHeader: true });
		// 	} else {
		// 		this.setState({ isScrolling: false, isHideInHeader: false });
		// 	}
		// }
		// this.setState({ offsetScroll: window.pageYOffset });
	}, 100);

	animate = (node, done) => {
		if (this.props.in) {
			this.setState({ animationState: 'in' });
			setTimeout(done, parseInt(css.animationInTime, 10));
		} else {
			this.setState({ animationState: 'out' });
			setTimeout(done, parseInt(css.animationOutTime, 10));
		}
	};

	categoryId = () => {
		return this.props.match.params.categoryId;
	};

	changeCategory = categoryId => {
		this.props.history.push(CATEGORY_ROUTE.replace(':categoryId', categoryId));
	};

	render() {
		const categoryId = this.categoryId();
		const { isStarted, categories } = this.props;
		const { animationState } = this.state;
		const cssTProps = _.omit(this.props, [
			'className',
			'isStarted',
			'staticContext',
			'history',
			'getCategorySelection',
			'setCategorySelection',
			'submitSelection',
			'getItems',
			'items',
			'selection',
			'categories',
			'getCategories',
			'isFetching',
		]);

		const isDesktop = Responsive.isMatching(Responsive.DESKTOP);

		return (
			<CSSTransition {...cssTProps} addEndListener={this.animate}>
				<div className={classNames(css.category, isStarted && css[animationState])}>
					<Header
						className={css.header}
						isCategory
						isHideInHeader={this.state.isHideInHeader}
						isScrolling={this.state.isScrolling}
						isSticky={!isDesktop}
						categoryMobileTitle={CATEGORY_TITLES[categoryId].categoryTitleMobile}
					/>
					{isDesktop && (
						<div
							className={css.genearlBg}
							style={{ backgroundImage: 'url(/assets/client/imgs/general-bg.png)' }}
						></div>
					)}

					<Container
						className={classNames(
							css.categoryContainer,
							!_.get(categories, [categoryId])?.isImageTemplate && css.containerWithSearch
						)}
					>
						{categoryId && (
							<>
								<Category
									categoryId={categoryId}
									items={this.props.items}
									user={this.props.user}
									isFetching={this.props.isFetching}
									getItems={this.props.getItems}
									getCategorySelection={this.props.getCategorySelection}
									setCategorySelection={this.props.setCategorySelection}
									getCategories={this.props.getCategories}
									submitSelection={this.props.submitSelection}
									history={this.props.history}
									isScrolling={this.state.isScrolling}
									categories={categories}
									changeCategory={this.changeCategory}
								/>
							</>
						)}
					</Container>
					<RabbiCredit className={css.rabbiCredit} theme="light" />
				</div>
			</CSSTransition>
		);
	}
}

CategoryContainer.propTypes = {};

export default CategoryContainer;
